export default __webpack_public_path__ + "static/media/notfound-illustration.5c60bf45.svg";